import React from 'react';
import { Box, Heading, VStack, Button, HStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const SettingsMenu = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Box>
      <Heading size="lg" mb={6}>{t('settings.title') || 'Settings'}</Heading>
      <VStack align="start" spacing={4}>
        <HStack>
          <Button onClick={() => navigate('/settings/language')}>Language</Button>
        </HStack>
        <HStack>
          <Button onClick={() => navigate('/settings/templates')}>Templates</Button>
        </HStack>
        <HStack>
          <Button onClick={() => navigate('/settings/rules')}>Rules</Button>
        </HStack>
        <HStack>
          <Button onClick={() => navigate('/settings/general')}>General</Button>
        </HStack>
        <HStack>
          <Button onClick={() => navigate('/settings/pdf')}>PDF Settings</Button>
        </HStack>
        <HStack>
          <Button onClick={() => navigate('/settings/service-categories')}>Service Categories</Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default SettingsMenu;
